import { ref, Ref, watchEffect } from "vue"
import { commentsApi } from "../store/api"
import { ResponseError } from "../interfaces/error.interface"

export default function useDeleteComment(commentId: string): {
  isPending: Ref<boolean>
  isSuccess: Ref<boolean>
  error: Ref<ResponseError | null>
} {
  const isSuccess: Ref<boolean> = ref(false)
  const error: Ref<ResponseError | null> = ref(null)
  const isPending: Ref<boolean> = ref(false)

  async function deletePostComment(): Promise<void> {
    isSuccess.value = false
    isPending.value = true
    error.value = null
    try {
      await commentsApi.deleteComment(commentId)
      isSuccess.value = true
    } catch (err: ResponseError) {
      error.value = err
    } finally {
      isPending.value = false
    }
  }

  watchEffect(deletePostComment)

  return {
    isPending,
    isSuccess,
    error,
  }
}
